import styled from 'styled-components';
import { rem } from 'polished';
import { Flexbox } from '../Flexbox/Flexbox';
import { FormInputComponent } from '../FormInputComponent';

export const ShopperFormGrid: any = styled(Flexbox)`
  width: 100%;
  margin: ${({ theme }) =>
    theme.formElements.gridItem.margin ||
    `0 ${rem(-15)} ${rem(45)} ${rem(-15)}`};
  ${({ theme }) => theme.media.m`
    margin-bottom: ${rem(30)};
  `};
  ${({ theme }) => theme.media.s`
    margin: 0 0 ${rem(30)} 0;
  `};
`;

export const ShopperFormGridRow: any = styled(Flexbox)`
  width: 100%;
  flex-wrap: wrap;
  ${({ theme }) => theme.media.s`
    flex-direction: column;
    align-items: center;
  `};
`;

export const ShopperFormGridItem: any = styled(Flexbox)`
  width: 50%;
  padding: ${({ theme }) =>
    theme.formElements.gridItem.padding || `${rem(15)}`};
  ${({ theme }) => theme.media.s`
    width: 100%;
    padding: ${rem(15)} 0;
    padding: ${theme.formElements.gridItem.paddingMediaS || `${rem(15)} 0`};
  `};
`;

export const StyledFormInput: any = styled(FormInputComponent)`
  width: 100%;
`;

export const SmallForm: any = styled(StyledFormInput)`
  width: ${rem(140)};
  margin-left: ${rem(15)};
`;
